<template>
  <div id="resumo-proposta">
    <v-row>
      <v-col cols="12" class="py-0 grey--text text--darken-3 font-weight-medium">
        <v-row>
          <v-col cols="7" lg="6" md="6" class="pb-0">
            <span class="text-h5">Dados Gerais</span>
          </v-col>
          <v-col v-if="$user.roles === 'Multiplo.Master'" cols="12" lg="6" md="6" class="py-0 ma-0 text-right">
            <v-btn @click="openAnaliseCredito" color="primary" >Revisar análise de crédito</v-btn>
          </v-col>
          <v-col v-if="resumoProposta" cols="12" class="pb-0 text-right">
            <v-chip outlined small>Situação: {{model.SituacaoDescricao}}</v-chip>
          </v-col>
          <v-col cols="12">
            <span class="text-label">Documento Federal</span>
              {{model.Cliente.DocumentoFederal}}
          </v-col>
          <v-col cols="12">
            <span class="text-label">Nome / Razão Social</span>
              {{model.Cliente.Nome}}
          </v-col>
          <v-col cols="6">
            <span class="text-label">Data de Nascimento</span>
              {{$api.UI.Format.Date(model.Cliente.DtNascimento)}}
          </v-col>
          <v-col cols="6">
            <span class="text-label">Telefone (Celular)</span>
              {{model.Cliente.TelefoneCelular}}
          </v-col>
          <v-col cols="12" >
            <span class="text-label">Nome da Mãe</span>
              {{model.Cliente.NomeMae}}
          </v-col>
          <v-col cols="6">
            <span class="text-label">Endereço de Instalação</span>
              <p v-if="model.Cliente.EnderecoInstalacao">{{model.Cliente.EnderecoInstalacao.toUpperCase()}}</p>
          </v-col>
          <v-col cols="6">
            <span class="text-label">Endereço de Residência</span>
              <p v-if="model.Cliente.EnderecoResidencia">{{model.Cliente.EnderecoResidencia.Logradouro}}, {{model.Cliente.EnderecoResidencia.NroLogradouro}}, {{model.Cliente.EnderecoResidencia.Cidade}}, {{model.Cliente.EnderecoResidencia.UF}} - {{model.Cliente.EnderecoResidencia.CEP}}</p>
          </v-col>

          <v-col cols="6">
            <span class="text-label">Renda Declarada</span>
              <p v-if="model.Cliente.ValorRenda">{{ $api.UI.Format.Currency(model.Cliente.ValorRenda) }}</p>
          </v-col>
          <v-col cols="6">
            <span class="text-label">Conta de Luz</span>
              <p v-show="model.Cliente.ValorContaLuz">{{ $api.UI.Format.Currency(model.Cliente.ValorContaLuz) }}</p>
          </v-col>

          <v-col cols="6">
            <span class="text-label">Tipo de Operação</span>
            {{ model.TipoOperacaoDescricao }}
          </v-col>
          <v-col cols="6">
            <span class="text-label">Produto</span>
            {{ model.TipoContratoDescricao }}
          </v-col>
        </v-row>

        <v-row class="grey lighten-3 mt-4">
          <v-col cols="4">
            <span class="text-label">Prazo</span>
            {{ $api.UI.Format.Date(model.PrimeiraParcela.DtVencimento) }} até
            {{ $api.UI.Format.Date(model.UltimaParcela.DtVencimento) }}
          </v-col>
          <v-col cols="4" class="text-center">
            <span class="text-label">Número de Prestações</span>
            Primeiras 12 prestações de R$ {{ $api.UI.Format.Decimal( model.PrimeiraParcela.VlrPrestacaoTotal ) }}
          </v-col>
          <v-col cols="4" class="text-right">
            <span class="text-label">Valor da 1ª prestação</span>
            {{
              $api.UI.Format.Currency(model.PrimeiraParcela.VlrPrestacaoTotal)
            }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pb-0 mt-6">
            <span class="text-h5">Detalhamento do Crédito</span>
          </v-col>

          <v-col cols="12" style="max-width: 800px" class="px-0">
            <div class="item-value">
              <span class="text-value-label">Valor Líquido Solicitado</span>
              <span class="text-value">{{
                $api.UI.Format.Currency(vlrLiquidoSolicitado)
              }}</span>
            </div>

            <template>
              <div class="item-value" v-if="model.VlrOutrasDespesas">
                <span class="text-value-label">Valor da Mão de Obra</span>
                <span class="text-value">{{
                  $api.UI.Format.Currency(model.VlrOutrasDespesas || 0)
                }}</span>
              </div>
            </template>

            <div class="item-value">
              <span class="text-value-label">Valor Equipamento</span>
              <span class="text-value">{{
                $api.UI.Format.Currency(model.VlrProdutoBem)
              }}</span>
            </div>

            <div class="item-value grey lighten-3 py-2 my-2">
              <span class="text-value-label">Valor Total Solicitado</span>
              <span class="text-value">{{
                $api.UI.Format.Currency(model.VlrSolicitado)
              }}</span>
            </div>

            <div class="item-value">
              <span class="text-value-label">Taxa de Juros</span>
              <span class="text-value">{{ $api.UI.Format.Decimal(model.PercJurosMensal) }}% a.m.
                {{ $api.UI.Format.Decimal(model.PercJurosAnual) }}% a.a.</span>
            </div>

            <div class="item-value mt-5">
              <span class="text-value-label">1º Prestação</span>
              <span class="text-value">
                {{ $api.UI.Format.Date(model.PrimeiraParcela.DtVencimento)
                }}<br />
                {{
                  $api.UI.Format.Currency(
                    model.PrimeiraParcela.VlrPrestacaoTotal
                  )
                }}
                <br />
                <span class="text-caption">
                  Taxa de Juros a.m.:
                  {{ $api.UI.Format.Decimal(model.PercJurosMensal) }}%
                  {{
                    model.TipoIndexador === 2
                    ? "+ " + model.IndexadorPosFixado
                    : ""
                  }}
                </span>
              </span>
            </div>

          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="pb-0 mt-6">
            <span class="text-h5">Fluxo de Pagamento</span>
          </v-col>
          <v-col cols="12" class="px-2 pt-0">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">Parcela</th>
                    <th class="text-center">Vencimento</th>
                    <th class="text-center">Dias Corridos</th>
                    <th class="text-right">Prestação</th>
                    <th class="text-right">Saldo Devedor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="model.Parcelas.length === 0">
                    <td colspan="7" class="text-center text--disabled">
                      Aguardando geração das parcelas
                    </td>
                  </tr>
                  <tr v-for="(item, index) in model.Parcelas" :key="index">
                    <template v-if="index < 3 || (verTodasParcelas && index < 12)">
                      <td class="text-center">
                        {{ (item.NumeroParcela || index) + 1 }}
                      </td>
                      <td class="text-center">
                        {{ $api.UI.Format.Date(item.DtVencimento) }}
                      </td>
                      <td class="text-center">
                        {{ item.Dias }} {{ item.Dias === 1 ? "dia" : "dias" }}
                      </td>
                      <td class="text-right">
                        {{ $api.UI.Format.Currency(item.VlrPrestacaoTotal) }}
                      </td>
                      <td class="text-right">
                        {{
                          item.VlrSaldoDevedor !== null
                          ? $api.UI.Format.Currency(item.VlrSaldoDevedor)
                          : "-"
                        }}
                      </td>
                    </template>
                    <td role="button" v-else-if="index === 3" colspan="7"
                      class="text-center text-decoration-underline primary--text" @click="verTodasParcelas = true">
                      ver todas as parcelas
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <template v-if="resumoProposta && isLoaded">
          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Documentos do Emitente</span>
            </v-col>
            <v-col cols="12">
              <DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Pessoa" resumo :codigoProposta="model.Codigo" :codigoPessoa="model.CodigoCliente" :key="model.Codigo"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Documentos da Proposta</span>
            </v-col>
            <v-col cols="12">
              <PropostaDocumento resumo :codigoProposta="model.Codigo"></PropostaDocumento>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Devedores Solidários</span>
            </v-col>
            <v-col cols="12">
              <PropostaAvalista resumo :value="model"></PropostaAvalista>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Garantias</span>
            </v-col>
            <v-col cols="12">
              <PropostaGarantia resumo :value="model"></PropostaGarantia>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
    <PropostaResumoAnalise resumo ref="resumoAnalise" />
  </div>
</template>
<script>
export default {
  components: {
    PropostaDocumento: () => import('@/views/PropostaDocumento.vue'),
    PropostaAvalista: () => import('@/views/PropostaAvalista.vue'),
    PropostaGarantia: () => import('@/views/PropostaAddGarantias.vue'),
    PropostaResumoAnalise: () => import('@/views/PropostaResumoAnalise.vue'),
  },
  props: {
    resumoProposta: { type: Boolean, default: false },
    modal: { type: Boolean, default: false },
  },
  data () {
    return {
      DtoConsultaMotor: null,
      model: {
        Cliente: {},
        Parcelas: {},
        PrimeiraParcela: {},
        UltimaParcela: {},
        VlrOutrasDespesas: 0,
      },
      isLoaded: false,
      verTodasParcelas: false
    };
  },
  computed: {
    vlrLiquidoSolicitado () {
      return this.model.VlrSolicitado - (this.model.VlrOutrasDespesas || 0)
    },
  },
  methods: {
    load (model) {
      this.$api.UTIL.Functions.SetAllButNull(this, this, 'model', model);
      this.listPropostaCampoAuxiliar(model.Codigo)
      this.getDadosCliente()
      this.isLoaded = true;
    },
    listPropostaCampoAuxiliar (codigoProposta) {
      const th = this
      const dto = {
        parameters: [{ name: 'CodigoProposta', value: codigoProposta }],
      };
      th.$api.Multiplo.ListPropostaCampoAuxiliar(dto).then(
        (response) => {
          if (th.$api.UI.PostLoadData(response, true)) {
            if (response.Data && response.Data.length > 0) {
              response.Data.forEach((item) => {
                if (item.NomeCampo === 'PROPOSTA_CONSULTAMOTOR') {
                  th.DtoConsultaMotor = JSON.parse(item.ValorCampo);
                }
                if (item.NomeCampo === 'VALOR_OUTRAS_DESPESAS') {
                  th.model.VlrOutrasDespesas = item.ValorCampo;
                }
                if (item.NomeCampo === 'EnderecoInstalacao') {
                  th.$set(th.model.Cliente, 'EnderecoInstalacao', item.ValorCampo)
                };
                if (item.NomeCampo === 'ValorContaLuz') {
                  th.$set(th.model.Cliente, 'ValorContaLuz', item.ValorCampo)
                }
                if (item.NomeCampo === 'ValorRenda') {
                  th.$set(th.model.Cliente, 'ValorRenda', item.ValorCampo)
                }
              });
            }
          }
        }
      );
    },
    getDadosCliente () {
      const th = this;
      if (th.model.Cliente.DocumentoFederal) {
        th.$api.Multiplo.SelectPessoa({ filter: { tipoRegistro: 1, DocumentoCliente: th.model.Cliente.DocumentoFederal } }).then(pessoa => {
          if (th.$api.UI.PostLoadData(pessoa)) {
            const pessoaObject = JSON.parse(pessoa.JSON)
            th.$set(th.model, 'Pessoa', pessoaObject)
            th.$set(th.model.Cliente, 'DtNascimento', pessoaObject.PF.DtNasc)
            th.$set(th.model.Cliente, 'TelefoneCelular', pessoaObject.PessoaDadosContato.TelefoneCelular1)
            th.$set(th.model.Cliente, 'NomeMae', pessoaObject.PF.NomeMae)
            const dtoPessoa = { parameters: [{ name: 'CodigoPessoa', value: th.model.Cliente.Codigo }] }
            th.$api.Multiplo.ListPessoaEndereco(dtoPessoa).then(endereco => {
              if (th.$api.UI.PostLoadData(endereco) && endereco.Data.length > 0) {
                th.$set(th.model.Cliente, 'EnderecoResidencia', endereco.Data[endereco.Data.length - 1])
              }
            })
          }
        })
        th.$api.Multiplo.ListPessoaQualificacao({ parameters: [{ name: 'CodigoPessoa', value: th.model.Cliente.Codigo }] }).then(qualificacao => {
          if (th.$api.UI.PostLoadData(qualificacao) && qualificacao.Data.length > 0) {
            th.$set(th.model.Cliente, 'PessoaQualificacao', qualificacao.Data[qualificacao.Data.length - 1])
          }
        })
      }
    },
    openAnaliseCredito () {
      const th = this;
      if (th.DtoConsultaMotor) {
        th.$api.BMPCred.NovaOperacaoUnica(th.DtoConsultaMotor).then(response => {
          if (th.$api.UI.PostLoadData(response, true)) {
            var dadosLimite = {}
            if (response.tomadores) {
              dadosLimite = response.tomadores.find(p => p.proposito === 'Aprovacao')
              dadosLimite.observacao.resultado = dadosLimite.resultado
              th.$set(th.model, 'DadosIniciais', dadosLimite.observacao)
              th.$set(th.model, 'Pessoa', th.model.Cliente)
              th.$set(th.model.Pessoa, 'Documento', th.model.Pessoa.DocumentoFederal)
              th.$api.Bureau.validaBureaus(th, th.model.Pessoa.Documento, response.bureaus || [], () => th.$refs.resumoAnalise.openModal(th.model))
            } else {
              th.$api.UI.ShowError('Erro', response);
            }
          }
        })
      } else {
        th.$api.UI.ShowError('Erro', 'Não há dados para consulta ao motor');
      }
    }
  },
};
</script>

<style>
#resumo-proposta span.text-label {
  display: block;
  font-weight: 400;
}

#resumo-proposta span.text-h5 {
  font-weight: 400;
}

#resumo-proposta div.item-value {
  padding-bottom: 2px;
  padding-top: 2px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: space-between;
}

#resumo-proposta span.text-value-label,
#resumo-proposta span.text-subtitle-1 {
  font-weight: 400;
}

#resumo-proposta span.text-value {
  text-align: end;
}
</style>
